
import { Box, Button, Card, Typography } from "@mui/material";
import ListaVazia from "../../../../utils/listaVazia";
import ObservacoesFeitas from "../../dlif/observacoesFeitas";
// import EncaminhaExpedienteAreas from "./encaminhaExpedienteAreas";
import { useNavigate, useParams } from "react-router-dom";
import Relatorios from "../../../../relatorioEspontaneo/relatoriosEspontaneos";
// import { temPermissao } from "../../../../utils/permissoes";

export default function NavLateral({ expediente, observacoesFeitas }) {
  const navigate = useNavigate();
  const { id } = useParams();

  return (
    <>
      <Card style={{ padding: 20 }}>
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", placeItems: 'center' }}>
          <img src="/icones/expediente/entrada.svg" alt="img" width={'70%'} />
        </div>

        <Typography m align="center">
          Estado do expediente
          <br />
          <b>Em {expediente.status} </b>
        </Typography>

        <Box>
          <br />
          {expediente?.status !== "Finalizado" ? (

            <Button
              // disabled={!temPermissao(user, ['encaminharExpediente'])}
              fullWidth
              size="small"
              color="success"
              // variant={action === "approve" ? "contained" : "outlined"}
              variant="outlined"
              onClick={() => navigate(`/admin/dadg/expediente/encaminhar/${id}`)}
            >
              Encaminhar Expediente
            </Button>

          ) : (
            <ListaVazia text={"Processo já análisado!"} />
          )}
        </Box>
      </Card >
      <br />

      {/* RELATORIOS ESPOTANEOS */}
      <Relatorios processoId={expediente?._id} modelName="expediente" />

      {
        observacoesFeitas?.length > 0 && (
          <ObservacoesFeitas observacoesFeitas={observacoesFeitas} />
        )
      }
    </>
  );
}
